<template>
  <div>
    <h1>Encountered Domains</h1>
    <div v-if="!requested_data" style="padding:20px;background-color: palegoldenrod">
      Awaiting Data
    </div>
    <div v-else-if="!encountered_domains || encountered_domains.length === 0" style="padding:20px;background-color: lightgray">
      There is no encountered domain data for the requested extent and job chain id.
      {{no_data_text}}
    </div>
    <div v-else>
      <el-tree
          :data="encountered_domains"
          node-key="id"
          ref="tree"
      >
        <template v-slot:default="node">
          <div>
            <span v-if="node.data.show_priority" >
                <span v-if="node.data.cached_analysis">
                    <span v-if="!(node.data.cached_analysis.data.cms || node.data.cached_analysis.data.analytics || node.data.cached_analysis.data.web_servers)">
                        No CMS, Analytics, or Web Server identified.
                    </span>
                    <span v-if="node.data.cached_analysis.data.cms" style="margin-right: 10px;">
                        CMS:
                        <span v-for="technology in node.data.cached_analysis.data.cms.technologies">
                            <a :href="technology.website" target="_blank">
                              <img style="padding:2px" height="20px" :src="'/images/tech-icons/' + technology.icon" :alt="technology.name" />
                            </a>
                        </span>
                    </span>
                    <span v-if="node.data.cached_analysis.data.analytics" style="margin-right: 10px;">
                        Analytics:
                        <span v-for="technology in node.data.cached_analysis.data.analytics.technologies">
                            <a :href="technology.website" target="_blank">
                              <img style="padding:2px" height="20px" :src="'/images/tech-icons/' + technology.icon" />
                            </a>
                        </span>
                    </span>
                    <span v-if="node.data.cached_analysis.data.web_servers" style="margin-right: 10px;">
                        Web Server:
                        <span v-for="technology in node.data.cached_analysis.data.web_servers.technologies">
                              <a :href="technology.website" target="_blank">
                                  <img style="padding:2px" height="20px" :src="'/images/tech-icons/' + technology.icon" />
                              </a>
                        </span>
                    </span>
                </span>
                <span v-else>
                    <span v-if="node.data.process_state">
                        {{node.data.process_state}}
                    </span>
                    <span v-else>
                         <span @click="fingerprint(node.data.example_url_target_1,node.data.id)">T</span>
                    </span>
                </span>
                <img @click="priority_select(node.data.domain,node.data.possible_extent_id,node.data.id)" width="10px" height="10px" :src="'/images/icons/' + node.data.priority_image" />
            </span>
            <span v-else>
                <span v-if="node.data.selections[-1]||node.data.selections[1]">

                    <span v-if="node.data.selections[-1]" style="color:red;background-color:#f5eeed;padding:2px;">{{node.data.selections[-1]}}</span>
                    <span v-if="node.data.selections[1]" style="color:white;background-color:green;padding:2px;">{{node.data.selections[1]}}</span>

                </span>
                 </span>
            <strong>
            <span>{{ node.data.domain }}</span>
            <span style="color:saddlebrown;">{{ node.data.count_text }}
              <span v-if="node.data.count>1">links</span>
              <span v-else>link</span>
            </span>
            </strong>
            <span v-if="node.data.fulldomain_count">
              ({{node.data.fulldomain_count}}
              <span v-if="node.data.fulldomain_count>1">domains)</span>
              <span v-else>domain)</span>
            </span>
            <span v-if="node.data.example_url_source_1">
              <a :href="node.data.example_url_source_1"  target="_blank">
              {{node.data.example_url_source_1}}
              </a>
              →
              <a :href="node.data.example_url_target_1"  target="_blank">
              {{node.data.example_url_target_1}}
              </a>
            </span>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "EncounteredDomains",
  props: ['extent_id_from_blade','job_chain_id'],
  mounted() {
    axios.get('/api/encountered_domains/' + this.extent_id_from_blade + '?job_chain_id=' + this.job_chain_id)
        .then(response => {
          this.requested_data = true
          console.log("encountered domains:")
          console.log(response.data)
          this.encountered_domains = response.data
          if (this.encountered_domains.length===0) {
            if (this.job_chain_id) {
              this.no_data_text = 'Encountered domain analysis was requested for a specific crawl. No encountered domain data was found for this crawl. This may be because the crawl happened prior to history of encountered domains.'
            } else {
              this.no_data_text = 'Either this site has never completed a crawl, the last crawl did not complete successfully, or the last crawl was done before this feature was enabled.'
            }
          }
        })
        .catch(error => {
          this.requested_data = true
          this.no_data_text = 'Error attempting to get the encountered domain data.'
          console.log('oops getting encountered domains')
        })
  },
  data() {
    return {
      encountered_domains: null,
      requested_data: false,
      no_data_text: ''
    }
  },
  methods: {
      set_process_state(encountered_id, process_state) {
          this.encountered_domains.forEach((rootdomain, index) => {
              let node_index = rootdomain.children.findIndex(child => {return child.id === encountered_id})
              if (node_index !== -1) {
                  rootdomain.children[node_index].process_state = process_state
                  this.$set(this.encountered_domains, index, rootdomain)
                  this.$refs.tree.updateKeyChildren(
                      encountered_id,
                      rootdomain.children[node_index]
                  )
                  console.log('Just set!')
                  console.log('encountered_id:')
                  console.log(encountered_id)
                  console.log('data:')
                  console.log(rootdomain.children[node_index])
              }

          })
      },
      fingerprint(url,encountered_id) {
          this.set_process_state(encountered_id,'fingerprinting now')
          console.log('starting fingerprinting')
          axios.post('/api/encountered_domains/' + this.extent_id_from_blade + '/' + encountered_id + '/fingerprint', {
              url: url,
          }).then(response => {
              console.log('posted fingerprint')
              this.set_process_state(encountered_id,'done fingerprinting (refresh page to see the results)')
          }).catch(error => {
              this.set_process_state(encountered_id,'could not get fingerprint')
              this.error_text = error.response.data
              console.log('oops posting fingerprint')
              console.log(error.response)
          })
      },
      priority_select(domain,possible_extent_id,encountered_id) {
          let next_value = 0
          // 'np_question_670398_CCCCCC.png'
          // 'np_yes_77494_4F8F00.png'
          // 'np_no_77518_941100.png'
          this.encountered_domains.forEach(root_group => {
              root_group.children.forEach(encountered => {
                  if (encountered.id===encountered_id) {
                      if (encountered.priority_image === 'np_question_670398_CCCCCC.png') {
                          root_group.selections[0]--
                          encountered.priority_image = 'np_yes_77494_4F8F00.png'
                          next_value = 1
                      } else if (encountered.priority_image === 'np_yes_77494_4F8F00.png') {
                          root_group.selections[1]--
                          encountered.priority_image = 'np_no_77518_941100.png'
                          next_value = -1
                      } else {
                          root_group.selections[-1]--
                          encountered.priority_image = 'np_question_670398_CCCCCC.png'
                          next_value = 0
                      }
                      root_group.selections[next_value]++
                  }
              })
          })
          axios.post('/api/encountered_domains/' + this.extent_id_from_blade + '/' + encountered_id, {
              value: next_value
          }).then(response => {
              console.log('set')
          }).catch(error => {
              this.error_text = error.response.data
              console.log('could not set')
              console.log(error.response)
          })
      }
  }
}
</script>

<style scoped>

</style>